import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-right, margin, padding"><path d="M16.25 3C16.4489 3 16.6396 3.07907 16.7803 3.21973C16.9209 3.36038 17 3.55109 17 3.75V20.25C17 20.6642 16.6642 21 16.25 21H3.75C3.55109 21 3.36038 20.9209 3.21973 20.7803C3.07907 20.6396 3 20.4489 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H16.25Z" fill="currentColor"/><path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21C19.8358 21 19.5 20.6642 19.5 20.25V3.75C19.5 3.33579 19.8358 3 20.25 3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutRight;
